const Flickity = require('flickity');

require('flickity-fullscreen');
require('flickity-as-nav-for');
require('@/lib/flickity/slider-lazysizes');
require('@/lib/flickity/slider-prev-next-buttons');
require('@/lib/flickity/slider-text-slide');
require('@/lib/flickity/slider-fullscreen');
// require('@/lib/flickity/slider-as-nav-for');
// require('@/lib/flickity/slider-page-dots');

const sliderElements = document.querySelectorAll('[data-flickity]');

const defaultConfig = {
  cellAlign: 'left',
  contain: true,
  groupCells: true,
  pageDots: false,
  // eslint-disable-next-line vue/max-len
  arrowShape: 'M66.043.949a3.538 3.538 0 0 1 1.151 2.623c0 .869-.314 1.737-.949 2.425L25.631 50.005l40.427 43.999c1.34 1.451 1.256 3.715-.202 5.047a3.567 3.567 0 0 1-5.043-.198L17.952 52.42a3.564 3.564 0 0 1 0-4.849L60.813 1.139c1.524-1.438 3.779-1.529 5.23-.19Z',
};

if (sliderElements && sliderElements.length) {
  import('@/scss/lib/flickity-slider.scss');

  sliderElements.forEach((sliderElement) => {
    let { flickity: dataConfig } = sliderElement.dataset;
    if (dataConfig) {
      dataConfig = JSON.parse(dataConfig);
    }

    const config = {
      ...defaultConfig,
      ...dataConfig,
      on: {
        ready() {
          setTimeout(() => {
            sliderElement.classList.add('flickity-ready');
          }, 500);
        },
      },
    };
    // eslint-disable-next-line no-new
    new Flickity(sliderElement, config);
  });
}
